<template>
  <div class="old-record-home">
    <!-- 导航 -->
    <Nav ref="Nav" />
    <!-- 轮播 -->
    <div class="home-banner">
      <div class="main-box">
        <div class="swiper-box swiper-container">
          <div class="swiper-wrapper">
            <div
              v-for="(banner, index) in bannerList"
              :key="'bannerList' + index"
              class="swiper-slide"
            >
              <div
                class="banner"
                @click="zhuantiJump(encodeURIComponent(banner['@id']))"
              >
                <img
                  :src="
                    banner.img
                  //saveImg('https://img.library.sh.cn/whzk/img/' + banner.img)
                      ? 'https://img.library.sh.cn/whzk/img/' + banner.img
                      : 'img/demo/banner.png'
                  "
                  alt=""
                />

                <div class="tit">
                  <span v-if="banner.title">
                    <router-link
                      :to="'/special/' + encodeURIComponent(banner['@id'])"
                    >
                      {{ banner.title }}
                    </router-link>
                  </span>
                </div>
                <div class="des" v-if="banner.description">
                  {{
                    banner.description.length > 180
                      ? banner.description.slice(0, 180) + "..."
                      : banner.description
                  }}
                </div>
                <div class="ctx">
                  <div class="g6-graph-box" :id="'mountNode' + index"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>
    <div class="home-record-list">
      <div class="main-box">
        <div class="home-tit">
          <div class="t-l">
            <span class="name"> <i class="record"></i>馆藏唱片 </span>
            <div class="filter">
              <!-- <router-link to="/">戏曲</router-link> -->
              <a
                :class="recodType[0] ? 'thisCur' : ''"
                @click="onPhonorecord('汉语', 0)"
                >中文</a
              >
              <a-divider type="vertical" />
              <a
                :class="recodType[1] ? 'thisCur' : ''"
                href="javascript:;"
                @click="onPhonorecord('英语', 1)"
                >外文</a
              >
            </div>
          </div>
          <router-link to="/record-depot" class="all">全部<i></i></router-link>
        </div>
        <div class="record-list">
          <!-- 放10种 -->
          <div
            v-for="(item, index) in recordList.slice(0, 10)"
            :key="'recordList' + index"
            class="record-cell"
          >
            <div class="pic">
              <router-link
                :to="'/rec-info/' + encodeURIComponent(item['@id'])"
                v-if="item.title"
              >
                <img
                  v-if="item.cover && item.cover.length"
                  :src="
                    item.cover[0]
                      ? 'https://img.library.sh.cn/hisdata/cp/img/' +
                        item.cover[0]
                      : baseRecordPic
                  "
                  alt=""
              /></router-link>
              <div
                class="h-box"
                v-if="item.playable"
                @click="playSong(item, index)"
              ></div>
            </div>
            <router-link
              :to="'/rec-info/' + encodeURIComponent(item['@id'])"
              class="tit"
              v-if="item.title"
              :title="
                item.title
                  .replace('~', '')
                  .replace('=', '')
                  .replace(':', '')
                  .replace(/[||]/g, '#')
                  .replace(/##/g, '')
              "
            >
              {{
                item.title
                  .replace("~", "")
                  .replace("=", "")
                  .replace(":", "")
                  .replace(/[||]/g, "#")
                  .replace(/##/g, "")
              }}</router-link
            >
            <div class="info" v-if="item.creator">{{ item.creator }}</div>

            <div v-if="!isMobile && item.date" class="info">
              {{ item.date }}
            </div>
          </div>
          <div class="clear-f"></div>
        </div>
      </div>
    </div>
    <div class="home-songs">
      <div class="main-box">
        <div class="home-tit">
          <div class="t-l">
            <span class="name"> <i class="song"></i>精选曲目 </span>
          </div>
          <router-link to="/song-depot" class="all">全部<i></i></router-link>
        </div>
        <div class="songs-list">
          <div
            class="songs-cell"
            v-for="(songArr, name, index) in songList"
            :key="'songList' + index"
          >
            <!-- <div class="tit"><i></i>{{name}}<b class="tit-right" @click="lplay(songArr,index)"><img :src="lbcur == index ? bf : zt" width="20"/>连播</b></div> -->
            <div class="tit">
              <i></i>{{ name
              }}<b class="tit-right" @click="lplay(songArr, index)"
                ><img :src="lbcur == index ? zt : zt" width="20" />连播</b
              >
            </div>
            <div class="line"></div>
            <div class="list">
              <div
                v-for="(song, index) in songArr"
                :key="'songArr' + index"
                class="cell"
              >
                <template>
                  <router-link
                    :to="'/song-detail/' + encodeURIComponent(song['@id'])"
                    class="name"
                    v-if="song.title"
                    :title="song.dctitle['@value']"
                  >
                    {{ song.dctitle["@value"] }}
                  </router-link>
                  <p>
                    <!-- <router-link :to="'/musician-detail/'+encodeURIComponent(song['@id'])" v-if="song.creator">
                      {{song.creator}}
                    </router-link> -->
                    <span v-if="song.creator">{{
                      song.creator.slice(0, 10) + "..."
                    }}</span>
                  </p>
                  <p>
                    <span v-if="song.year">{{
                      song.year.slice(0, 10) + "..."
                    }}</span>
                  </p>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="celebrities-list">
      <div class="main-box">
        <div class="home-tit">
          <div class="t-l">
            <span class="name"> <i class="musician"></i>乐人名家 </span>
          </div>
          <router-link to="/musician-depot" class="all"
            >更多<i></i
          ></router-link>
        </div>
        <div class="celebrities-box">
          <div
            v-for="(item, index) in celebritiesList"
            :key="'celebritiesList' + index"
            class="celebrities"
          >
            <div class="pic">
              <router-link
                :to="'/musician-detail/' + encodeURIComponent(item['@id'])"
              >
                <img v-if="item.img" :src="item.img" alt="" />
                <div
                  v-else
                  :class="
                    'base-pic-placeholder bg' + parseInt(Math.random() * 6)
                  "
                >
                  {{ item.name["@value"].substring(0, 1) }}
                </div>
              </router-link>
            </div>
            <div class="info">
              <router-link
                :to="'/musician-detail/' + encodeURIComponent(item['@id'])"
                class="name"
                v-if="item.name"
              >
                {{ item.name["@value"] }}
              </router-link>
              <p v-if="item.briefBiography" :title="item.briefBiography">
                <router-link
                  :to="'/rec-info/' + encodeURIComponent(item['@id'])"
                >
                  {{ item.briefBiography }}
                </router-link>
              </p>
              <!-- <p><router-link to="/rec-info/1">{{item.works2}}</router-link></p> -->
            </div>
          </div>
          <div class="clear-f"></div>
        </div>
      </div>
    </div>
    <Footer class="has-player" />
    <Player ref="player" @curPlay="curPlay" />
  </div>
</template>

<script>
import Nav from "@/components/nav";
import Footer from "@/components/footer";
import Player from "@/components/player";
import { baseMusicPic, baseRecordPic } from "@/util/basePic";
import {
  phonorecordCollections,
  musicInfo,
  phonorecordInfo,
  phonorecordHome,
  musicRecommondationsGet,
  personFamous,
  collectionRelations,
} from "@/api";
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
  navigator.userAgent
);
export default {
  name: "Home",
  components: {
    Nav,
    Footer,
    Player,
  },
  data() {
    return {
      timer:null, //定时器名称 chenss 2022-09-13
      lbcur: -1,
      isMobile,
      zt: require("../../assets/images/icon/Group.png"),
      bf: require("../../assets/images/icon/pause.png"),
      playIndex: -1,
      curIndex: -1,
      baseMusicPic,
      recodType: [false, false],
      player: [],
      playerList: [],
      baseRecordPic,
      noplay: false,
      phonorecordParam: null,
      bannerList: [],
      bannerSwiper: null,
      visible: false,
      audioDetail: [],
      swiperOptions: {
        loop: false,
        freeMode: false,
        preventClicksPropagation: true,
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
          pauseOnMouseEnter: true,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        // transitionEnd: (swiper, index)=>{
        //   //console.log(swiper) //切换结束时，告诉我现在是第几个slide
        //   //console.log(index) //切换结束时，告诉我现在是第几个slide
        // },
        on: {
          init: this.initG6,
          transitionStart: () => {
            // 切换
            setTimeout(() => {
              // if(this.bannerSwiper) this.bannerSwiper.clear();
              this.g6Graph.forEach((g6) => {
                if (g6) {
                  g6.clear();
                  g6.render();
                }
              });
              let activeIndex = this.bannerSwiper.activeIndex;
              this.nodeBannerDetail = this.bannerList[activeIndex];
              this.collectionRelations();
            }, 200);
          },
        },
      },
      recordList: [],
      songList: [],
      celebritiesList: [],
      relationsData: {},
      dataType: {
        phonorecord: "唱片",
        music: "曲目",
        person: "乐人",
        organization: "机构团体",
      },
      banner: require("./../../../public/img/demo/banner.png"),
      g6Graph: [], // 实例化
      secondLabbelIdArr: [], // 二级节点ID储存
      g6GraphData: {
        // 数据
        nodes: [
          {
            id: "node0",
            type: "circular-image",
            size: 80,
            img: require("./../../../public/img/demo/image.png"),
            clipCfg: {
              // 裁剪图片配置
              show: false,
              type: "circle",
              r: 40,
              x: 0,
              y: 0,
            },
          },
          { id: "node1", size: 50, label: "外滩", isLeaf: true },
          { id: "node2", size: 50, label: "1", isLeaf: true },
          { id: "node3", size: 50, label: "地点", isLeaf: true },
          { id: "node4", size: 50, label: "人物", isLeaf: true },
          { id: "node5", size: 50, label: "1", isLeaf: true },
          { id: "node6", size: 50, label: "电影", isLeaf: true },
          { id: "node7", size: 60, label: "相关事件", isLeaf: true },
        ],
        edges: [
          { source: "node0", target: "node1" },
          { source: "node0", target: "node2" },
          { source: "node0", target: "node3" },
          { source: "node0", target: "node4" },
          { source: "node1", target: "node5" },
          { source: "node2", target: "node6" },
          { source: "node4", target: "node7" },
        ],
      },
      g6GraphLayout: {
        // 布局
        type: "force", // force:经典的力导向布局
        preventOverlap: true, // 是否防止重叠
        collideStrength: 1, // 防止重叠的力强度，范围 [0, 1]
        linkDistance: (d) => {
          // 边长度
          if (d.source.id === this.rootNodeId) {
            return 200;
          }
          return 80;
        },
        nodeStrength: (d) => {
          // 节点作用力，正数代表节点之间的引力作用，负数代表节点之间的斥力作用
          if (d.isLeaf) {
            return -50;
          }
          return -10;
        },
        edgeStrength: (d) => {
          // 边的作用力，默认根据节点的出入度自适应
          if (this.edgeStrengthList.indexOf(d.source.id) != -1) {
            return 0.7;
          }
          return 0.1;
        },
      },
      edgeStrengthList: [], // 节点ID储存
      nodeBannerDetail: {},
      rootNodeId: "node0", // 根节点ID
      nodeType: [
        { type: "phonorecord", name: "唱片", units: "种", url: "/rec-info/" },
        { type: "person", name: "乐人", units: "人", url: "/musician-detail/" },
        {
          type: "organization",
          name: "机构团体",
          units: "个",
          url: "/company-detail/",
        },
        { type: "music", name: "曲目", units: "", url: "/song-detail/" },
      ],
    };
  },
  beforeRouteLeave(to, form, next) {
    this.$refs.player.savePlayer();
    next();
  },
  computed: {
    rootNodeData() {
      // 根节点
      const IMG_URI = this.nodeBannerDetail.img
        ? "https://img.library.sh.cn/whzk/img/" + this.nodeBannerDetail.img
        : this.banner;
      return {
        id: this.rootNodeId,
        type: "circular-image",
        label: this.nodeBannerDetail.title,
        isLeaf: false,
        size: isMobile ? 40 : 90,
        img: IMG_URI,
        x: Math.ceil(Math.random() * 50), // 随机x位置
        y: Math.ceil(Math.random() * 50), // 随机y位置
        style: {
          width: isMobile ? 40 : 90,
          lineWidth: 2,
          shadowOffsetX: 2,
        },
        clipCfg: {
          // 裁剪图片配置
          show: false,
          type: "circle",
          r: isMobile ? 20 : 45,
          x: 0,
          y: 0,
        },
        labelCfg: {
          position: "bottom",
          offset: 10,
          style: {
            fill: "#ffffff",
            textAlign: "center",
            r: isMobile ? 20 : 45,
            // x: -50,
            y: 60,
            lineWidth: 2,
            shadowOffsetX: 2,
          },
        },
      };
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.query();
      this.timer = setInterval(() => {//定时刷新 chenss 2022-09-13
       setTimeout(this.query, 0);
       console.log('执行了定时刷新...');
   }, 1000*1800)//半小时
    });
  },
  methods: {
    // 对图片进行缓存的方法
    async saveImg(imgUrl) {
      let url = localStorage.getItem(imgUrl);
      if (url) {
        console.log("使用了本地缓存的图片..."+url);
        return url;
      } else {
        console.log("未缓存图片,延迟下载并缓存...");
        setTimeout(function () {
          var img = new Image();
          img.src = imgUrl;
          img.crossOrigin = "*"; // 允许跨域访问
          img.onload = function () {
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, img.width, img.height);
            var dataUrl = canvas.toDataURL("image/png");
            localStorage.setItem(imgUrl, dataUrl); // 缓存图片
            console.log("加载图片成功..."+dataUrl);
          };
          img.onerror = function () {
            console.log("加载图片失败...");
          };
        }, 10);
        return imgUrl;
      }
    },
    async initG6() {
      setTimeout(() => {
        this.g6Graph.forEach((g6) => {
          if (g6) {
            g6.clear();
            g6.render();
          }
        });
        let activeIndex = this.bannerSwiper.activeIndex;
        this.nodeBannerDetail = this.bannerList[activeIndex];
        this.collectionRelations();
      }, 200);
    },
    async query() {
      await this.phonorecordCollectionsQuery();
      await this.phonorecordHomeQuery();
      await this.musicRecommondationsGetQuery();
      await this.personFamousQuery();
      setTimeout(() => {
        this.initSwiper();
      }, 100);
    },
    async zhuantiJump (id) {
      this.$router.push({
        path: "/special/" + id,
      });
    },
    async nohandleCancel() {
      this.noplay = false;
    },
    async phonorecordCollectionsQuery() {
      // 专题
      const res = await phonorecordCollections();
      const result = res.data.datas;
      this.bannerList = result;
      // //console.log(result);
    },

    async phonorecordHomeQuery() {
      // 馆藏唱片
      const res = await phonorecordHome(this.phonorecordParam);
      const result = res.data.datas;
      this.recordList = result;
      // //console.log(result);
    },
    async musicRecommondationsGetQuery() {
      // 精选曲目
      const res = await musicRecommondationsGet();
      const result = res.data.datas;
      this.songList = result;
      // //console.log(result);
    },
    async personFamousQuery() {
      // 乐人名家
      const res = await personFamous();
      const result = res.data.datas;
      this.celebritiesList = result;
      // //console.log(result);
    },
    async onPhonorecord(data, n) {
      // 中，英文单击切换
      this.recodType.splice(n, 1, !this.recodType[n]);
      this.recodType.forEach((item, index) => {
        if (n != index) {
          this.recodType[index] = false;
        }
      });
      //如果没选中，则进行空检。不传入任何语言标记
      if (!this.recodType[n]) {
        data = "";
      }
      //console.log(n+'-------'+this.recodType[n]);
      // //console.log(data);
      this.phonorecordParam = {
        subject: data,
      };
      this.phonorecordHomeQuery();
    },
    async collectionRelations() {
      // 关系图表
      this.queryUri = this.nodeBannerDetail["@id"];
      let g6data = [];
      if (localStorage.getItem(this.queryUri) == null) {
        //如果缓存中没有，则取接口数据 chenss 2022-09-13
        const res = await collectionRelations({ collection: this.queryUri });
        const result = res.data;
        localStorage.setItem(this.queryUri, JSON.stringify(result.datas)); //放入緩存
      }
      g6data = JSON.parse(localStorage.getItem(this.queryUri)); //获取缓存数据
      this.g6GraphDataHandle(g6data);
    },
    async g6GraphDataHandle(datas) {
      this.edgeStrengthList = [];
      let newNodes = [];
      let newEdges = [];
      this.g6GraphData = {
        nodes: newNodes,
        edges: newEdges,
      };
      // 节点
      const nodes = datas.nodes;
      // 连接线
      const edges = datas.edges;
      // 连接线维护判断-重置根节点ID
      let edgesFlag = true;
      edges.forEach((item, index) => {
        // 节点关系调整
        let edgeSource = item.source;
        let edgeTarget = item.target;
        this.nodeType.forEach((ntItem, ntIndex) => {
          const nodeTypeName = ntItem.name;
          const nodeTypeType = ntItem.type;
          if (
            edgeSource.indexOf("http") === 0 &&
            edgeTarget.indexOf(nodeTypeName) !== -1
          ) {
            if (edgesFlag) {
              // 重置根节点ID
              this.rootNodeId = edgeSource;
              edgesFlag = false;
            }
          }
        });
        if (edgeSource.indexOf("http") === 0) {
          newEdges.push(item);
          this.edgeStrengthList.push(edgeSource);
        }
      });

      let nodesFlag = true;
      // 节点数据调整
      nodes.forEach((item, index) => {
        let nodeId = item.id;
        let nodeName = item.name;
        let nodeCount = item.name1;
        this.nodeType.forEach((ntItem, ntIndex) => {
          const nodeTypeName = ntItem.name;
          const nodeTypeType = ntItem.type;
          const nodeTypeUnits = ntItem.units;
          // 二级节点调整
          if (nodeId === nodeName && nodeId.indexOf(nodeTypeName) !== -1) {
            if (isMobile && nodeName == "机构团体") {
              nodeName = "机构";
            }
            item.label = nodeName + "\n" + nodeCount + nodeTypeUnits;
            item.size = isMobile ? 40 : 60;
            item.isLeaf = true;
            item.style = {
              fill: "#cb5554",
              color: "#fff",
            };
            item.labelCfg = {
              style: {
                fill: "#fff", // 二级节点字体颜色
              },
            };
            newNodes.push(item);
          }
          // 三级节点调整
          // if(nodesFlag && nodeId.indexOf(nodeTypeType) != -1){
          //   item.label = nodeName;
          //   item.size = isMobile ? 40 : 60;
          //   item.isLeaf = true;
          //   item.style = {
          //     width: 150,
          //     fill:'#DA984A',     // 三级节点外边框颜色
          //     stroke: '#DA984A',  // 三级节点背景色
          //     lineWidth: 2,
          //   };
          //   item.labelCfg = {
          //     style: {
          //       fill: '#fff',     // 三级节点字体颜色
          //       cursor: 'pointer'
          //     },
          //   };
          //   newNodes.push(item);
          //   nodesFlag = false;
          // }
        });
      });
      // 加入根节点
      newNodes.push(this.rootNodeData);
      this.g6GraphData = {
        nodes: newNodes,
        edges: newEdges,
      };
      // //console.log(newNodes);
      // //console.log(newEdges);
      // 自定义节点初始化
      this.g6RegisterNode();
      this.registerNodeRoundRect();
      setTimeout(() => {
        // G6初始化
        this.g6GraphInit();
      }, 100);
    },
    graphHideItem(index) {
      // 默认隐藏三级节点
      const graphNodes = this.g6Graph[index].getNodes();
      graphNodes.forEach((gn) => {
        const gnModel = gn.getModel();
        const gnNodeId = gnModel.id;
        this.nodeType.forEach((ntItem, ntIndex) => {
          const nodeTypeType = ntItem.type;
          if (
            gnNodeId != this.rootNodeId &&
            gnNodeId.indexOf(nodeTypeType) != -1
          ) {
            this.g6Graph[index].hideItem(gnNodeId);
          }
        });
      });
    },
    initSwiper() {
      // Swiper初始化
      if (this.bannerSwiper) this.bannerSwiper.destroy(false);
      this.bannerSwiper = new this.$Swiper(
        ".swiper-container",
        this.swiperOptions
      );
    },
    registerNodeRoundRect() {
      // 节点定义
      const _this = this;
      // 定义节点
      _this.$G6.registerNode(
        "round-rect",
        {
          drawShape: function drawShape(cfg, group) {
            const width = cfg.style.width;
            const stroke = cfg.style.stroke;
            const fill = cfg.style.fill;
            const rect = group.addShape("rect", {
              attrs: {
                x: -width / 2,
                y: -15,
                width: width,
                height: 30,
                radius: 15,
                fill: fill,
                stroke: stroke,
                lineWidth: cfg.style.lineWidth,
                fillOpacity: cfg.style.fillOpacity || 0,
              },
              name: "rect-shape",
            });
            group.addShape("circle", {
              attrs: {
                x: -width / 2,
                y: 0,
                r: 3,
                fill: fill,
              },
              name: "circle-shape",
            });
            group.addShape("circle", {
              attrs: {
                x: width / 2,
                y: 0,
                r: 3,
                fill: fill,
              },
              name: "circle-shape2",
            });
            return rect;
          },
          // getAnchorPoints: function getAnchorPoints() {
          //   return [
          //     [0, 0.5],
          //     [1, 0.5],
          //   ];
          // },
          update: function update(cfg, item) {
            const group = item.getContainer();
            const children = group.get("children");
            const node = children[0];
            const circleLeft = children[1];
            const circleRight = children[2];

            const stroke = cfg.style.stroke;

            if (stroke) {
              node.attr("stroke", stroke);
              circleLeft.attr("fill", stroke);
              circleRight.attr("fill", stroke);
            }
          },
        },
        "single-node"
      );
    },
    g6RegisterNode() {
      // 自定义节点
      const _this = this;
      _this.$G6.registerNode(
        "circular-image",
        {
          draw(cfg, group) {
            // 如果 cfg 中定义了 style 需要同这里的属性进行融合
            const keyShape = group.addShape("circle", {
              attrs: {
                x: cfg.style.x || 0,
                y: cfg.style.y || 0,
                r: cfg.style.radius || cfg.clipCfg.r || 80,
                lineWidth: cfg.style.lineWidth,
                fill: cfg.style.fill,
                stroke: cfg.style.stroke,
                fillOpacity: cfg.style.fillOpacity || 0,
              },
              name: "circle-image-shape",
              draggable: true,
            });
            // 如果有图片，则传入图片
            if (_this.relationshipGraphImage || cfg.img || cfg.style.img) {
              // 节点内置图片
              group.addShape("image", {
                attrs: {
                  x: -cfg.size || 0,
                  y: -cfg.size / 2 || 0,
                  // width: cfg.size,
                  height: cfg.size,
                  img: _this.relationshipGraphImage || cfg.img || cfg.style.img,
                },
                zIndex: 0,
                name: "my-image-shape",
                capture: true,
                // 设置 draggable 以允许响应鼠标的图拽事件
                draggable: true,
              });
              // 裁剪图片
              const shape = group.get("children")[1];
              shape.setClip({
                type: "circle", // 支持 circle、rect、ellipse、Polygon 及自定义 path clip
                attrs: cfg.clipCfg,
              });
            }
            // 如果有文本
            if (cfg.label) {
              // 如果需要复杂的文本配置项，可以通过 labeCfg 传入
              const style = (cfg.labelCfg && cfg.labelCfg.style) || {};
              style.text = cfg.label;
              group.addShape("text", {
                // attrs: style
                attrs: style,
                name: "my-text-shape",
                // 设置 draggable 以允许响应鼠标的图拽事件
                draggable: true,
              });
            }
            return keyShape;
          },
        },
        "circle"
      );
    },
    g6GraphInit() {
      // 初始化 g6
      this.bannerList.forEach((item, index) => {
        const mountNode = document.getElementById("mountNode" + index);
        if (!mountNode) {
          return false;
        }
        const width = mountNode.scrollWidth;
        const height = mountNode.scrollHeight || 422;
        this.g6Graph.push(
          new this.$G6.Graph({
            container: "mountNode" + index,
            width,
            height,
            // fitView: true, // 超出画布自适应
            // fitViewPadding: [10, 10, 10, 10],
            animate: true, // Boolean，切换布局时是否使用动画过度，默认为 false
            layout: this.g6GraphLayout, // 布局
            defaultEdge: {
              // 线配置
              style: {
                stroke: "#ffffff",
                lineWidth: 2,
              },
            },
            defaultNode: {
              // 节点配置
              // type: 'image',
              // color: '#ebe9da',
              style: {
                fill: "#F2994A",
                stroke: "#fff",
                lineWidth: 2,
              },
              labelCfg: {
                // 文字配置
                style: {
                  fill: "#ffffff",
                  fontFamily: "SourceHanSansCN-Medium",
                },
              },
            },
            modes: {
              default: ["drag-canvas"],
            },
          })
        );
        this.g6Graph[index].findAll("node", (node) => !node.hasLocked());
        this.onGraphFun(mountNode, index);
        // 更改所有子节点层级
        this.toFrontHandle(index);
        // 隐藏三级节点
        this.graphHideItem(index);
      });
    },
    toFrontHandle(index) {
      // 更改所有子节点层级
      // 数据
      const nodes = this.g6Graph[index].getNodes();
      nodes.forEach((gn) => {
        const gnModel = gn.getModel();
        const gnNodeId = gnModel.id;
        if (gnNodeId !== this.rootNodeId) {
          gn.toFront();
        }
      });
      // 更改层级后需要重新绘制图
      this.g6Graph[index].paint();
      // 刷新
      this.g6Graph[index].layout(true);
    },
    onGraphFun(el, index) {
      // 数据
      const nodes = this.g6GraphData.nodes;
      this.g6Graph[index].data({
        nodes,
        edges: this.g6GraphData.edges.map((edge, i) => {
          edge.id = "edge" + i;
          return Object.assign({}, edge);
        }),
      });
      // 根据提供的数据渲染视图
      this.g6Graph[index].render();
      let dblclickCount = 0;
      this.g6Graph[index].on("node:dblclick", (evt) => {
        // 双击
        const targetItem = evt.item;
        const model = targetItem.getModel();
        dblclickCount++;
        if (dblclickCount == 2) {
          dblclickCount = 0;
          return;
        }
        const uri = model.id;
        if (uri.indexOf("http:") != -1) {
          try {
            this.nodeType.forEach((ntItem, ntIndex) => {
              const nodeTypeType = ntItem.type;
              const nodeTypeUrl = ntItem.url;
              if (uri.indexOf(nodeTypeType) != -1) {
                this.$router.push(nodeTypeUrl + encodeURIComponent(uri));
                // 跳出循环
                throw new Error("breakForEach");
              }
            });
          } catch (e) {
            if (e.message != "breakForEach") throw e;
          }
        }
        // this.hideClick(evt, index);
      });
      this.g6Graph[index].on("click", (evt) => {
        // 单击
        this.hideClick(evt, index);
      });
      this.g6Graph[index].on("node:dragstart", (e) => {
        this.g6Graph[index].layout();
        this.refreshDragedNodePosition(e);
      });
      this.g6Graph[index].on("node:drag", (e) => {
        this.refreshDragedNodePosition(e);
      });
      this.g6Graph[index].on("node:dragend", (e) => {
        e.item.get("model").fx = null;
        e.item.get("model").fy = null;
      });

      if (typeof window !== "undefined") {
        window.onresize = () => {
          if (!this.g6Graph[index] || this.g6Graph[index].get("destroyed"))
            return;
          if (!el || !el.scrollWidth || !el.scrollHeight) return;
          this.g6Graph[index].changeSize(el.scrollWidth, el.scrollHeight);
        };
      }
    },
    hideClick(evt, index) {
      const node = evt.item;
      const model = node.getModel();
      const nodeId = model.id;
      const graphEdges = this.g6Graph[index].getEdges();
      const graphNodes = this.g6Graph[index].getNodes();
      // 节点 隐藏/显示
      graphNodes.forEach((gn) => {
        const gnModel = gn.getModel();
        const gnNodeId = gnModel.id;
        this.nodeType.forEach((ntItem, ntIndex) => {
          const nodeTypeName = ntItem.name;
          const nodeTypeType = ntItem.type;
          // 三级节点 隐藏/显示
          if (
            nodeId != gnNodeId &&
            nodeId == nodeTypeName &&
            gnNodeId.indexOf(nodeTypeType) != -1
          ) {
            if (gn.isVisible()) gn.hide();
            else gn.show();
          }
        });
        // 根节点下所有节点 隐藏/显示
        if (nodeId == this.rootNodeId && nodeId != gnNodeId) {
          if (rootNodeFlag) {
            gn.show();
          } else gn.hide();
        }
      });
      // 节点连接线 隐藏/显示
      graphEdges.forEach((ge) => {
        const geModel = ge.getModel();
        const geSource = geModel.source;
        const geTarget = geModel.target;
        this.nodeType.forEach((ntItem, ntIndex) => {
          const nodeTypeName = ntItem.name;
          const nodeTypeType = ntItem.type;
          // 三级节点连接线 隐藏/显示
          if (nodeId == nodeTypeName && geTarget.indexOf(nodeTypeType) != -1) {
            if (ge.isVisible()) ge.hide();
            else ge.show();
          }
        });
        // 根节点下所有节点 隐藏/显示
        if (nodeId == this.rootNodeId) {
          if (rootNodeFlag) ge.show();
          else ge.hide();
        }
      });
      // 根节点点击 显示/隐藏 控制
      if (nodeId == this.rootNodeId) rootNodeFlag = !rootNodeFlag;
      // 刷新
      this.g6Graph[index].layout(true);
      //console.log('node:click');
    },
    reRender(index) {
      // 重新渲染
      const Util = this.g6Graph[index].Util;
      this.g6Graph[index].clear();
      this.g6Graph[index].read(Util.clone(this.g6GraphData));
      this.g6Graph[index].render();
    },
    refreshDragedNodePosition(e) {
      const model = e.item.get("model");
      model.fx = e.x;
      model.fy = e.y;
    },
    handleOk() {
      this.isLogin = true;
      this.visible = false;
    },
    handleCancel() {
      this.visible = false;
    },
    curPlay() {
      this.playIndex = this.curIndex;
    },
    async playSong(item, index) {
      this.curIndex = index;
      this.$refs.player.playSong(this.$refs.Nav, item);
    },
    lplay(data, index) {
      // console.log(this.GLOBAL.BASE_IP_INFO.ip+'----AAA--'+this.$refs.player.whiteIpFlag);
      if(!this.$refs.player.whiteIpFlag){//如果不是白名单，则依然走登录判断逻辑 chenss 20221014
      if (
        !localStorage.getItem("token") ||
        localStorage.getItem("token") == ""
      ) {
        this.$refs.Nav.showTk(1);
        return;
      }
    }
      let songData = [];
      data.forEach((item, i) => {
      
        // if (item["playable"]) { 20230131 chenss
        if (this.GLOBAL.BASE_IP_INFO.ipIsInner) {
          this.lbcur = index;
          songData.push({
            name: item["dctitle"]["@value"] ? item["dctitle"]["@value"] : "",
            artist: item["@id"],
            singer: item["@id"],
            url: item["audio"]["label"],
            isTry: false,
            isFavorite: item["isFavorite"],
          });
        }
      });
      if (songData.length <= 0) {
        //如果栏目下课播放曲目个数为0：该栏目暂无法播放 chenss
        this.$refs.Nav.showTk(5);
        return;
      }
      this.$refs.player.addList(songData);
    },
  },
  beforeDestroy() {
    if (this.bannerSwiper) this.bannerSwiper.destroy(false);
    clearInterval(this.timer);  //定时刷新 chenss 2022-09-13
    this.timer = null;
  },
};
</script>

<style lang="less" scoped>
.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 2px;
  @media (min-width: 1024px) {
    bottom: 25px;
  }
}
::v-deep {
  .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    border: 1px solid #fff;
    opacity: 1;
    background: none;
    margin: 0 2px !important;
  }
  .swiper-pagination-bullet-active {
    background: #fff;
  }
  @media (min-width: 1024px) {
    .swiper-pagination-bullet {
      width: 14px;
      height: 14px;
      border: 3px solid #fff;
      opacity: 1;
      background: none;
      margin: 0 6px !important;
    }
    .swiper-pagination-bullet-active {
      background: #fff;
    }
  }
}
</style>
